import React, { useEffect, useState } from "react";
import axios from "axios";

export default function SpaceContentDetailModal({ eventName, location, onClose }) {
    const [images, setImages] = useState([]);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/space-content/files`, {
                params: { event: eventName, location }
            })
            .then((res) => setImages(res.data))
            .catch(console.error);
    }, [eventName, location]);

    return (
        <div className="slow-animation fixed inset-0 bg-gray-500 bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white max-w-7xl w-full max-h-[100vh] overflow-y-auto rounded p-6 space-y-6">
                <div className="flex justify-between items-center">
                    <h2 className="text-lg font-bold">{eventName} - {location}</h2>
                    <div className="flex gap-4">
                        <button onClick={onClose} className="text-red-600">닫기</button>
                    </div>
                </div>

                <div className="flex flex-col items-center gap-6">
                    {images.map((img, i) => (
                        <img
                            key={i}
                            src={`${process.env.REACT_APP_API_REAL_URL}/${img}`}
                            alt={`img-${i}`}
                            className="max-w-[100%] h-auto rounded shadow"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}